export enum LogLevel {
  log = 3, // console.log is typically considered by most browsers as the same log level as console.info

  none = 0,
  error = 1,
  warn = 2,
  info = 3,
  debug = 4
}
